import reduceOpacity from '../../../../../common/utils/reduce-opacity';

const dark = (params) => {
  const { targetColor, backgroundColor } = params;
  const fallback = {
    rule: 'filePicker.button.border.disabled.light',
    params,
  };
  return reduceOpacity({
    targetColor,
    backgroundColor,
    opacity: 0.99,
    condition: (ratio) => ratio >= 1.04,
    fallback,
  });
};

export default dark;
